import { render, staticRenderFns } from "./channel__form.vue?vue&type=template&id=1e2c882a"
import script from "./channel__form.vue?vue&type=script&lang=js"
export * from "./channel__form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports